/**
 * Secure Storage
 *
 * XOR-based obfuscation wrapper around localStorage for session data.
 * Provides encode/decode to prevent casual inspection of stored values.
 *
 * Note: In production this should use Web Crypto API (AES-GCM) for
 * proper encryption. The current XOR approach is obfuscation only.
 */

const ENCRYPTION_KEY = 'xs-admin-portal-key';

function encode(data: string): string {
  return btoa(
    encodeURIComponent(data)
      .split('')
      .map((c, i) =>
        String.fromCharCode(
          c.charCodeAt(0) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length),
        ),
      )
      .join(''),
  );
}

function decode(encoded: string): string {
  const decoded = atob(encoded);
  return decodeURIComponent(
    decoded
      .split('')
      .map((c, i) =>
        String.fromCharCode(
          c.charCodeAt(0) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length),
        ),
      )
      .join(''),
  );
}

export const secureStorage = {
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, encode(value));
    } catch {
      // Storage full or unavailable — silently fail
    }
  },
  getItem(key: string): string | null {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return decode(raw);
    } catch {
      return null;
    }
  },
  removeItem(key: string): void {
    localStorage.removeItem(key);
  },
};
